import React, { Component } from "react";
import { CSSTransitionGroup } from "react-transition-group";
import { Cache } from "aws-amplify";
import { Mutation } from "react-apollo";
import {
  handleSubscription,
  subscribeUser,
  unsubscribeUser
} from "../../webNotifications";
import { message } from "antd";
import InstructionsNotifications from "./InstructionsNotifications";
import ActionWebToken from "../../GraphQL/Mutation/ActionWebToken";

class NotificationBubble extends Component {
  state = {
    isSubscribed: false,
    permissionDenied: false,
    bubbleVisible: false
  };

  async componentDidMount() {
    const isSubscribed = await handleSubscription();
    this.setState(
      {
        isSubscribed,
        bubbleVisible: !isSubscribed
      },
      () => {
        this.props.active(this.state.isSubscribed);
      }
    );
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.bubbleVisible !== prevProps.bubbleVisible) {
      this.setState({ bubbleVisible: !this.state.bubbleVisible });
    }
  }

  async handleSubscribe(mutate, action) {
    if (this.state.isSubscribed) {
      /////// va ir cuando se deslogue el usario
      const isSubscribed = await unsubscribeUser();
      this.setState({ isSubscribed, bubbleVisible: false }, () => {
        this.props.active(this.state.isSubscribed);
      });

      if (!isSubscribed) {
        const subscription = Cache.getItem("subscription");
        mutate({
          variables: {
            subscription,
            delete: action
          }
        })
          .then(() => {
            message.warning("Tu suscripción se ha cancelado con éxito.");
          })
          .catch(err => {
            console.log(err);
            message.error("Hubo un error al cancelar la suscripción.");
          });
      } else {
        message.error("Hubo un error al cancelar la suscripción.");
      }
    } else {
      const { subscription, permissionResult } = await subscribeUser();
      if (subscription && permissionResult === "granted") {
        mutate({
          variables: {
            subscription,
            delete: action
          }
        })
          .then(() => {
            message.success(
              "Gracias!, ahora podras recibir notificaciones en este dispositivo."
            );
          })
          .catch(err => {
            console.log(err);
            message.error(`Hubo un error al suscribirte intentelo mas tarde`);
          });
        this.setState({ isSubscribed: true, bubbleVisible: false }, () => {
          this.props.active(this.state.isSubscribed);
        });
      } else if (permissionResult === "denied") {
        message.warning("No podras recibir notificaciones en este dispositivo");
        this.setState({ permissionDenied: true, bubbleVisible: false });
      }
    }
  }

  render() {
    const { messengerVisible } = this.props;
    const { isSubscribed, bubbleVisible, permissionDenied } = this.state;
    return (
      <div
        className="oval-thought-border"
        style={{ bottom: messengerVisible ? "365px" : "56px" }}
      >
        <CSSTransitionGroup
          transitionName="third"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={200}
        >
          {bubbleVisible ? (
            <div className="oval-thought-border__third" />
          ) : null}
        </CSSTransitionGroup>
        <CSSTransitionGroup
          transitionName="second"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={100}
        >
          {bubbleVisible ? (
            <div className="oval-thought-border__second" />
          ) : null}
        </CSSTransitionGroup>
        <CSSTransitionGroup
          transitionName="first"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={50}
        >
          {bubbleVisible ? (
            <div className="oval-thought-border__first">
              <Mutation mutation={ActionWebToken}>
                {mutate =>
                  isSubscribed ? (
                    <button
                      className="button-notification"
                      onClick={() => this.handleSubscribe(mutate, isSubscribed)}
                    >
                      Cancelar suscripción
                    </button>
                  ) : (
                    <button
                      className="button-notification"
                      onClick={() => this.handleSubscribe(mutate, isSubscribed)}
                    >
                      Suscribirse a las notificaciones
                    </button>
                  )
                }
              </Mutation>
            </div>
          ) : null}
        </CSSTransitionGroup>
        <InstructionsNotifications
          permissionDenied={permissionDenied}
          close={() => this.setState({ permissionDenied: false })}
        />
      </div>
    );
  }
}

export default NotificationBubble;



// WEBPACK FOOTER //
// ./src/Components/Comments/NotificationBubble.js